export default "__VITE_PUBLIC_ASSET__e3a6ec45__"